// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"b812d55e","491":"54e80d71","644":"313997be","667":"1e5b1ea0"}[chunkId] + ".chunk.js";
};